import Vue from 'vue';
import axios from 'axios';
import SiteBody from '../components/body.vue';
import Bus from '../bus';
import Header from './header';
import Footer from './footer';
import search from '../components/search';
import canvasy from '../components/canvasy';
import canvasyMain from '../components/canvasy-main';
import {mapState, mapActions, mapMutations} from 'vuex';
import {closest} from '../utils'
import {Tabs, Tab} from '../../node_modules/vue-tabs-component/src/index.js';
import Plyr from 'plyr';
import 'plyr/dist/plyr.css';
Vue.component('tabs', Tabs);
Vue.component('tab', Tab);
import scrollLock from 'scroll-lock';

import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css'; // only if your build system can import css, otherwise import it wherever you would import your css.

Vue.use(VuePlyr);
import plyrVideo from '../components/video.vue';

//компонент форм
import VFC from 'vfc';
import 'vfc/dist/vfc.css'
Vue.use(VFC);
//маска
import Inputmask from "inputmask";

//акордион
import VueCollapse from 'vue2-collapse'
Vue.use(VueCollapse);

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
  events: 'change'
});


import { SweetModal, SweetModalTab } from 'sweet-modal-vue';

//слайдер
Vue.component('swiper', function (resolve) {
  require(['vue-awesome-swiper/src/swiper'], resolve);
});
Vue.component('swiperSlide', function (resolve) {
  require(['vue-awesome-swiper/src/slide'], resolve);
});
require('swiper/dist/css/swiper.min.css');

//скрол к элементу
let VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo);

Vue.directive('mobile-mg', {
  inserted: function (el, binding) {
    // Переключаем фокус на элемент
    if (appConfig.mobileVersion)
      el.style.cssText = 'background-image:url("'+binding.value+'");';
    //console.log(binding)
  }
});

export default {
  data() {
    return {
      pageData: window.PAGE_DATA,
      isMobile: appConfig.mobileVersion,
      desktopVersion: appConfig.desktopVersion,
      mobileMenuIsOpen: false,
      files: [],
      filesCarrier: [],
      isShowSideMenu: false,
      inputArea: '',
      form: {
        email: '',
        name: '',
        check: false,
        phone: '',
        textarea: '',
        theme: '',
        file: ''
      },
      formRules: {
        email: [
          {required: true, message: 'Email is required'},
          {type: 'email', message: 'Email is not correct'}
        ],
        check: [
          {pattern: /true/, message: 'Terms is required'}
        ],
        name: [
          {required: true, message: 'name is required'}
        ],
        phone: [
          {required: true, message: 'City is required'}
        ],
        // textarea: [
        //     { required: true, message: 'City is required' }
        // ],
        //theme: {required: true, message: 'name is required'}
      },
      optionsCallback: [{label: 'отдел кадров1', value: 1}, {label: 'отдел кадров1', value: 2}],
      formCallback: {
        email: '',
        name: '',
        check: false,
        phone: '',
        textarea: '',
        theme: '',
        file: ''
      },
      formRulesCallback: {
        email: [
          {required: true, message: 'Email is required'},
          {type: 'email', message: 'Email is not correct'}
        ],
        check: [
          {pattern: /true/, message: 'Terms is required'}
        ],
        name: [
          {required: true, message: 'name is required'}
        ],
        // phone: [
        //     { required: true, message: 'City is required' }
        // ],
        // textarea: [
        //     { required: true, message: 'City is required' }
        // ],
        theme: {required: true, message: 'name is required'}
      },
      sliderMain: {//базовый слайдер сос страници стилей
        slidesPerView: 1,
        //spaceBetween: 14,
        simulateTouch: true,
        loop: true,
        navigation: {
          nextEl: '.slider-main__arrow.next',
          prevEl: '.slider-main__arrow.prev',
        },
        pagination: {
          el: '.slider-main__pagination',
          type: 'fraction',
          formatFractionCurrent: function (number) {
            if (number < 10) {
              return `0${number}`
            }
            return number
          },
          formatFractionTotal: function (number) {
            if (number < 10) {
              return `0${number}`
            }
            return number
          },
        },
        breakpoints: {// Responsive breakpoints
          1100: {
            slidesPerView: 1,
            spaceBetween: 30
          },
          767: {
            slidesPerView: 1,
            spaceBetween: 0
          }
        }
      },
      sweetModalMsg: {
        title: '',
        text: '',
      },

      swiperOptionPartners: {
        slidesPerView: 7,
        slidesPerColumn: 3,
        slidesPerGroup: 7,
        //loop: true,
        // Responsive breakpoints
        breakpoints: {
            /*1100: {
                slidesPerView: 1,
                spaceBetween: 30
            },*/
            767: {
                slidesPerView: 3,
                slidesPerColumn: 3,
                slidesPerGroup: 3,
                spaceBetween: 0
            }
        },
        navigation: {
          nextEl: '.slider-arrow.right',
          prevEl: '.slider-arrow.left',
        },
      },
      /**
       * шаблон данных для шаблона формы
       */
      formTemplate: {
        email: '',
        name: '',
        check: '',
        phone: '',
        textarea: '',
        theme: '',
        file: ''
      },
      catalogCategoriesOpen: false
    };
  },
  methods: {
    ...mapActions(['showSideMenu']),
    showMenu(){
      const sideMenu = document.querySelector('.side-menu');
      const stateShow = sideMenu.classList.contains('show');
      if (!stateShow) {
        sideMenu.classList.add('show');
      }
    },
    toggleCatalogCategories() {
      this.catalogCategoriesOpen = !this.catalogCategoriesOpen;
    },
    hiddenCookie(e){
      axios({
        method: 'post',
        url: '/ajax/coockieAgree.php'
      }).then((response) => {
        if (response.status === 200) {
          const infoBlock = closest(e.target, '.info');
          infoBlock.classList.add('info--hidden');
          setTimeout(() => infoBlock.setAttribute('style', 'display:none'), 400);
        }
      });
    },
    async onSubmit (formRefs, url) {
      if (!formRefs) console.error('need formRefs parameter');
      let form = this.$refs[formRefs];
      let scopeForm = closest(form.$el, 'form').getAttribute('data-vv-scope');
      try {
        await form.validate();
        if(scopeForm)
          this.validateForm(scopeForm);
        if (url) {
          this.getResultCallback(url, formRefs);
        } else {
          let closestForm = closest(form.$el, 'form');
          let getUrl = closestForm.getAttribute('action');
          this.getResultCallback(getUrl, formRefs);
        }
      } catch (err) {
        console.warn('Form is not valid')
        console.warn(err)
      }
    },
    resetForm(refsForm) {
      for (let i in this[refsForm]) {
        i === 'check' ? this[refsForm][i] = false : this[refsForm][i] = ''
      }
      this.$refs[refsForm].resetValidation()
    },
    disableScroll(e) {
      e.preventDefault();
    },
    emailOpenHandler(){
      const navMail = document.querySelector('nav.side-menu__secondary--mail');
      if (!navMail.classList.contains('active')) {
        navMail.classList.add('active');
      }
      if (this.isMobile) {
        document.body.classList.add('is-fixed');
        let root = document.getElementsByTagName('html')[0];
        root.classList.add('is-fixed');

        let pageContent = document.querySelector('.page-content');

        pageContent.addEventListener('touchmove', this.disableScroll);

      }
    },
    emailCloseHandler(){
      const navMail = document.querySelector('nav.side-menu__secondary--mail');
      if (navMail.classList.contains('active')) {
        navMail.classList.remove('active');
      }
      if (this.isMobile) {
        document.body.classList.remove('is-fixed');
        let root = document.getElementsByTagName('html')[0];
        root.classList.remove('is-fixed');
        let pageContent = document.querySelector('.page-content');
        pageContent.removeEventListener('touchmove', this.disableScroll);
      }
    },
    previewFiles(e) {
        this.files = e.target.files[0];
        //console.log(e.target.files[0], 'changed');

        setTimeout(()=> {
            if(!e.target.classList.contains('invalid')){
                let filesArray = [...e.target.files];
                this.files = [];
                filesArray.forEach(file => {

                    let fileObject = {
                        name: file.name,
                        size: (file.size / 1000000).toFixed(2),
                        type: file.type
                    };

                    this.files.push(fileObject)
                });
            } else {
                e.target.value = null
                //this.clearFileReader();
                //console.log(e.target.files[0], 'changed');
            }

        }, 200)

    },
    clearingFile(){
        this.files = []
    },
    previewFilesCarrier(e) {
        this.filesCarrier = e.target.files[0];
        //console.log(e.target.files[0], 'changed');

        setTimeout(()=> {
            if(!e.target.classList.contains('invalid')){
                let filesArray = [...e.target.files];
                this.filesCarrier = [];
                filesArray.forEach(file => {

                    let fileObject = {
                        name: file.name,
                        size: (file.size / 1000000).toFixed(2),
                        type: file.type
                    };

                    this.filesCarrier.push(fileObject)
                });
            } else {
                e.target.value = null
                //this.clearFileReader();
                //console.log(e.target.files[0], 'changed');
            }

        }, 200)

    },
    clearingFileCarrier(){
        this.filesCarrier = []
    },
    showMessage(response) {
      //console.log('showMessage');
      this.sweetModalMsg.title = response.title;
      this.sweetModalMsg.text = response.msg;
      this.$refs.message.open();
    },
    getResultCallback(url, formRefs) {
      //console.log('getResultCallback');
      //let form = this.$refs[formRefs];
      let closestForm = closest(this.$refs[formRefs].$el, 'form');
      let data = new FormData(closestForm);
      axios({
        method: 'post',
        url: (url) ? url : '/h/test.php',
        data: data
      }).then((response) => {
        if (response.status === 200)
        ////console.log(response, 'response');
          this.showMessage(response.data);
        //this.commit('xxx', response.data);
        //alert(response.data.status);
        ////console.log('pending');
        this.resetForm(formRefs);
      });
    },
    playPresentVideo(){
      const btn = [...document.querySelectorAll('.js-play-present-video')];
      //console.log(btn, 'btn');
      btn.forEach(item => {
        let isStart = false;

        const parentNode = closest(item, '.present-video');
        const video = parentNode.querySelector('.present-video__video');

        video.addEventListener("ended", () => {
          video.removeAttribute('controls');
          isStart = false;
          item.classList.toggle('is-playing');
        });

        item.addEventListener('click', () => {
          const poster = parentNode.querySelector('.present-video__wrap-poster');

          item.classList.toggle('is-playing');

          if (!isStart) {
            poster.classList.add('hidden');
            video.play();
            video.setAttribute('controls', true);
            video.removeAttribute('muted');
            video.removeAttribute('loop');
            isStart = true;
          } else {
            poster.classList.remove('hidden');
            video.pause();
            video.removeAttribute('controls');
            isStart = false;
          }
        })
      })
    },
    toggleCheckbox(e){
      let checkboxValue = e.target.querySelector('input[type="checkbox"]').checked;
      //console.log(checkboxValue);
      checkboxValue = !checkboxValue;
    },
    /**
     * функция очистки шаблона формы
     * @param scope принимает идентификатор формы
     */
    clearForm(scope){
      for (let key in this.formTemplate) {
        this.formTemplate[key] = '';
      }
    },
    /**
     * валидация шаблона формы
     * @param scope принимает идентификатор формы
     */
    validateForm(scope) {
      this.$validator.validateAll(scope).then((result) => {
        //console.log(result)
        if (result) {
          let closestForm = closest(document.querySelector(`[data-vv-scope="${scope}"]`), 'form');

          grecaptcha.ready(() => {
            grecaptcha.execute('6Lc3DqwUAAAAABPwlXaSpCGuqZ8RNt-HU1DWcvzt', {action: 'test'}).then((token) => {

              let data = new FormData(closestForm);
              let url = closestForm.getAttribute('action');

              data.append('token', token);

              axios({
                method: 'post',
                url: (url) ? url : '/h/test.php',
                data: data
              }).then((response) => {
                if (closestForm.hasAttribute('data-tag')){
                  try {
                    gtag("event", "event_name", {
                      "event_category": closestForm.getAttribute('data-tag'),
                      "event_action": "send"
                    });

                    ym(53251990, 'reachGoal', closestForm.getAttribute('data-tag'));

                  }
                  catch (e) {
                    console.log(e);
                  }
                }
                if (response.status === 200)
                  this.clearingFile();//очистка визуализации input file форма сайд меню
                this.clearingFileCarrier();//очистка визуализации input file форма внизу страницы
                this.showMessage(response.data);
                //console.log(response, 'response');
                //console.log('pending');
                closestForm.reset();
                this.errors.clear();

              });

            });
          });


        }
      });
    },
    toggleMobileMenu() {
      this.mobileMenuIsOpen = !this.mobileMenuIsOpen;
    },
    openSecodaryMenu($event) {
      let subMenu = $event.target.parentNode.querySelector('.side-menu__secondary');
      if (subMenu) {
        subMenu.classList.add('is-open');
      }
    },
    closeSecodaryMenu($event) {
      let subMenu = $event.target.parentNode;
      if (subMenu) {
        subMenu.classList.remove('is-open');
      }
    },
    /**
     *
     * @param scope формы поиска
     */
    getResultFormSearch(scope) {
        this.$validator.validateAll(scope).then((result) => {
            if (result) {
                this.$refs.formGlob.submit();
            }
        })
    },
    /**
     * скролит страницу если в url есть hash
     */
    scrollToHref(){
      const hash = window.location.hash === '#callback';
      if(hash) {
          const element = document.getElementById('callback');
          element.scrollIntoView({ block: 'end',  behavior: 'smooth' });
      }
    },
    /**
     * @description при клике на элемение с data-attr, функция производит переход на адрес указанный в data-attr
     */
    setLocation(){
      const dataEl = [...document.querySelectorAll('[data-href]')];
      dataEl.forEach(el=>{
        el.addEventListener('mouseover', (e)=>{
          const parentNode = closest(e.target, '.catalog-card');
            parentNode.querySelector('.catalog-card__desc').setAttribute('style', 'color:#000000;')
        });
          el.addEventListener('mouseout', (e)=>{
              const parentNode = closest(e.target, '.catalog-card');
              parentNode.querySelector('.catalog-card__desc').setAttribute('style', '')
          });

        el.addEventListener('click', (e)=>{
          e.preventDefault();
          window.location = e.target.getAttribute('data-href')
        })
      })
    },
    redir(e){
        window.location = e.target.getAttribute('data-href')
    }

  },
  components: {
    SiteBody,
    search,
    canvasy,
    canvasyMain,
    SweetModal,
    SweetModalTab,
    plyrVideo
  },
  mixins: [Header, Footer],
  created() {
    window.setTimeout(() => this.showSideMenu(), 4000);
  },
  computed: {
    ...mapState(['isSideMenu', 'optionsMainForm']),
    catalogCategoriesIsOpen() {
      return this.isMobile ?  this.catalogCategoriesOpen : true;
    }
    /*{{contactListOtherOffice.length+contactListMainOffice.length}}
     {{
     wordCases(contactListOtherOffice.length+contactListMainOffice.length, ['производственные', 'производственных', 'производственных'])
     }}
     {{
     wordCases(contactListOtherOffice.length+contactListMainOffice.length, ['площадка', 'площадки', 'площадок'])
     }}*/
    /*wordCases() {
      return (count, words) => {
        let str = count.toString();
        let lastLetter = str[str.length - 1];
        switch (lastLetter) {
          case '1':
            if (str[str.length - 2] && str[str.length - 2] === '1') return words[2];
            return words[0];
          case '2':
          case '3':
          case '4':
            if (str[str.length - 2] && str[str.length - 2] === '1') return words[2];
            return words[1];
          default:
            return words[2];
        }
      }
    },*/
  },
  mounted() {
    window.setTimeout(() => this.showMenu(), 1500);

    if (this.desktopVersion) {
      document.querySelector('#viewport').setAttribute('content', 'width:1280px, initial-scale=1');
      document.querySelector('body').style.cssText = 'min-width: 1280px;';

      const players = [...document.querySelectorAll('[data-plyr-provider="youtube"]')].forEach((video) => {
        new Plyr(video, {
          autoplay: true,
          muted: true,
          loop: {
            active: true
          }
        });
      });

    }

    if (document.querySelector('.main-canvas')) {
      window.setTimeout(() => Bus.$emit('canvas-transform'), 1500);//вызов трансформации главного слайда
    }

    if (document.getElementById('PhoneNum')) {
      const im = new Inputmask("+7(999)999-99-99");
      im.mask(document.getElementById('PhoneNum').querySelector('.vue-input__inner'));
    }

    const sideMenuPhone = new Inputmask("+7(999)999-99-99");
    sideMenuPhone.mask(document.getElementById('sideMenuPhone').querySelector('.vue-input__inner'));

    if (document.getElementById('filesCallback')) {
      let fileLoaderdocument = document.getElementById('filesCallback').querySelector('input');
      fileLoaderdocument.addEventListener('change', this.previewFiles);
    }

    this.playPresentVideo();
    this.scrollToHref();
    this.setLocation();
  },
  directives: {
    mobileImg: {
      inserted: (el, binding) => {
        if (appConfig.mobileVersion) {
          el.style.cssText = 'background-image: url("'+binding.value+'");';
        }
        //console.log(binding);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/page.js